import React from 'react';
import { useIntl } from 'react-intl';

import { ListingPageButtonToggle } from '@futrli/ui-components/components/listing-page/listing-page-button-toggle/listing-page-button-toggle';

interface StatusFilterProps {
  onChange: (value: string) => void;
  selectedValue: string;
  isResourceSharingEnabled?: boolean;
}

export const StatusFilter = ({ onChange, selectedValue, isResourceSharingEnabled = false }: StatusFilterProps) => {
  const intl = useIntl();
  const label = isResourceSharingEnabled
    ? intl.formatMessage({ id: 'common.sharing', defaultMessage: 'Sharing' })
    : intl.formatMessage({ id: 'common.status', defaultMessage: 'Status' });

  const statusOptions = isResourceSharingEnabled
    ? [
      {
        label: intl.formatMessage({ id: 'predict.filters.status.all', defaultMessage: 'All' }),
        value: 'all'
      },
      {
        label: intl.formatMessage({ id: 'predict.filters.sharing.shared', defaultMessage: 'Shared' }),
        value: 'shared'
      },
      {
        label: intl.formatMessage({ id: 'predict.filters.sharing.private', defaultMessage: 'Private' }),
        value: 'private'
      }
    ]
    : [
      {
        label: intl.formatMessage({ id: 'predict.filters.status.all', defaultMessage: 'All' }),
        value: 'all'
      },
      {
        label: intl.formatMessage({
          id: 'predict.filters.status.published',
          defaultMessage: 'Published'
        }),
        value: 'published'
      },
      {
        label: intl.formatMessage({ id: 'predict.filters.status.draft', defaultMessage: 'Draft' }),
        value: 'draft'
      }
    ];

  return (
    <ListingPageButtonToggle
      label={label}
      options={statusOptions}
      selectedValue={selectedValue}
      onChange={onChange}
    />
  );
};
